import axios from "axios";
import {URL_PREFIX} from "../config";

export const getOpenCalls = (pageId=0, pageNum=10, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/open-calls/', {
      cancelToken: cancelToken?.token
  })
}

export const getOpenCallsHighlight = (pageId=0, pageNum=10, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/open-calls-highlight/', {
      cancelToken: cancelToken?.token
  })
}